









import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import SmsSendManager from '@/views/popups/member/SmsSendManager.vue';

@Component({
  components: { AdminIframe, SmsSendManager },
})
export default class SmsSendManagerIframe extends Vue {
  private get remoteSrc() {
    const query = this.$route.query;
    const queryObject = { serviceType: 'PRO', ...query };
    const queryString = new URLSearchParams(queryObject).toString();

    return process.env.VUE_APP_ADMIN_REMOTE_URL + this.$route.path + '?' + queryString;
  }
}
